import React, { Component } from "react";

class Announcement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: "📢 Admission open for new batches! Register today."
    };
  }

  render() {
    return (
      <div className="container my-4">
        <div className="alert alert-warning alert-dismissible fade show shadow" role="alert">
          <strong>Announcement:</strong> {this.state.text}
          <button type="button" className="btn-close" data-bs-dismiss="alert"></button>
        </div>
      </div>
    );
  }
}

export default Announcement;
